import { Component, Inject } from '@angular/core';
import { ISitemap, SITEMAP } from 'pbc.angular';
import { IFilterConfig, ISelection } from 'pbc.types';

import get from 'lodash/get';
import { Subscription } from 'rxjs';

import { BerichteQueryFilterConfig, IBerichteQueryShapes, IBerichteResponse } from 'fa-kt.types';
import { BerichteService } from '../service';

@Component({
  selector: 'fa-kt-berichte-filter',
  templateUrl: './berichte-filter.component.html',
  styleUrls: ['./berichte-filter.component.css'],
})
export class BerichteFilterComponent {
  readonly subscriptions: Subscription[] = [];

  public BerichteFilterConfig: IFilterConfig<IBerichteResponse>;

  constructor(
    @Inject(SITEMAP) private sitemap: ISitemap,
    public berichte: BerichteService,
  ) {
    this.BerichteFilterConfig = BerichteQueryFilterConfig.map((filter) => ({ ...filter, title: get(sitemap, filter.title, filter.title) as string }));
    /* << update mapper    */
    /*    update mapper >> */
  }

  ngOnInit() {
    this.subscriptions.push(
      this.berichte.shapes$.subscribe((shapes: IBerichteQueryShapes | undefined) => {
        if (!shapes) {
          return;
        }
        Object.entries(shapes)
          .filter(([key]) => key !== 'id' && (shapes as any)[key])
          .forEach(([key]) => this.shape(key, (shapes as any)[key]));
      }),
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(($) => $.unsubscribe());
  }

  private shape(field: string, shapes: ISelection[]): void {
    const index = this.BerichteFilterConfig.findIndex((f) => f.key === field);
    if (index < 0) {
      return;
    }
    this.BerichteFilterConfig[index].selections = shapes;
  }
}
